import React, { useState } from "react";
import contact_us from "../../assests/img/contact-us.jpg";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import map from "../../assests/img/map.png";
import clock from "../../assests/img/clock.png";
import contactUsImg from "../../assests/img/contact-us.png";
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { contactUsApi, websiteFeedback } from "../../services/api";
import { selectIsAuthenticated } from "../../redux/authSlice";
import Loader from "../common/Loader";

const ContactUs = () => {
  const [open, setOpen] = useState(false);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    subject: "",
    description: "",
  });

  const position = {
    lat: 30.707720417358967,
    lng: 76.68561100959779,
  };

  const onChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    setSuccess("");
    try {
      if (isAuthenticated) {
        await contactUsApi({
          subject: form.subject || "Website enquiry",
          description: form.description,
        });
      } else {
        await websiteFeedback({
          name: form.name,
          email: form.email,
          mobileNumber: form.mobileNumber,
          rating: 5,
          comment: `${form.subject ? form.subject + " — " : ""}${form.description}`,
        });
      }
      setSuccess("Message sent successfully. We will contact you soon.");
      setForm({
        name: "",
        email: "",
        mobileNumber: "",
        subject: "",
        description: "",
      });
    } catch (err) {
      setError(err.message || "Failed to send message");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Contact Kior Healthcare Mohali, Punjab | Tricity Diagnostics
        </title>
        <meta
          name="description"
          content="Kior Healthcare is a trusted pathology lab in Punjab and certified MRI center in Mohali. Contact us to book lab tests, MRI scans, and health checkup packages."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {submitting && <Loader overlay message="Sending message..." />}

      <section className="contact_us">
        <img src={contact_us} alt="Contact Kior Healthcare" />

        <section className="contact_intro py-4 py-md-5">
          <div className="coustom_container">
            <h1>Contact Us – Kior Healthcare</h1>
            <p>
              Contact Kior Healthcare, a trusted diagnostic centre in Mohali,
              for reliable medical testing, advanced imaging, and convenient
              home sample collection services.
            </p>
          </div>
        </section>

        <div className="coustom_container pb-5">
          <Row className="gy-4">
            <Col lg={4} md={6} sm={12}>
              <Card className="h-100 shadow border-0">
                <Card.Body className="text-center">
                  <div className="card-icon">
                    <img src={map} alt="Location" />
                  </div>
                  <Card.Title className="mt-3">
                    <strong>Our Location</strong>
                  </Card.Title>
                  <Card.Text>
                    C-210 P, Phase 8-B
                    <br />
                    Industrial Area
                    <br />
                    Mohali, Punjab
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <Card className="h-100 shadow border-0">
                <Card.Body className="text-center">
                  <div className="card-icon">
                    <img src={clock} alt="Working Hours" />
                  </div>
                  <Card.Title className="mt-3 fw-bold">Working Hours</Card.Title>
                  <Card.Text>
                    <strong>Open 24 Hours</strong>
                    <br />
                    Monday – Sunday
                    <br />
                    24×7
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <Card className="h-100 shadow border-0">
                <Card.Body className="text-center">
                  <div className="card-icon">
                    <img src={contactUsImg} alt="Contact" />
                  </div>
                  <Card.Title className="mt-3">
                    <strong>Contact Us</strong>
                  </Card.Title>
                  <Card.Text>
                    +91 8263000004
                    <br />
                    +91 9875964159
                    <br />
                    kiorhealthcare8b@gmail.com
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col lg={8} className="mx-auto">
              <Card className="shadow border-0 p-4">
                <h2 className="h4 mb-3" style={{ color: "#10519e" }}>
                  Send us a message
                </h2>
                {error && <Alert variant="danger">{error}</Alert>}
                {success && <Alert variant="success">{success}</Alert>}
                <Form onSubmit={onSubmit}>
                  {!isAuthenticated && (
                    <Row>
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            name="name"
                            value={form.name}
                            onChange={onChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={form.email}
                            onChange={onChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Mobile</Form.Label>
                          <Form.Control
                            name="mobileNumber"
                            value={form.mobileNumber}
                            onChange={onChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                  <Form.Group className="mb-3">
                    <Form.Label>Subject</Form.Label>
                    <Form.Control
                      name="subject"
                      value={form.subject}
                      onChange={onChange}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="description"
                      value={form.description}
                      onChange={onChange}
                      required
                    />
                  </Form.Group>
                  <Button
                    type="submit"
                    style={{ background: "#10519e", borderColor: "#10519e" }}
                    disabled={submitting}
                  >
                    {submitting ? "Sending..." : "Send message"}
                  </Button>
                </Form>
              </Card>
            </Col>
          </Row>
        </div>

        <div className="map_wrapper">
          <LoadScript googleMapsApiKey="AIzaSyDtD_XNYu8fhqQ9diEq4p_JeODJ-HAqKkQ">
            <GoogleMap
              mapContainerStyle={{
                width: "100%",
                height: "400px",
                borderRadius: "12px",
              }}
              center={position}
              zoom={18}
            >
              <Marker position={position} onClick={() => setOpen(true)} />
              {open && (
                <InfoWindow
                  position={position}
                  onCloseClick={() => setOpen(false)}
                >
                  <div style={{ maxWidth: "220px" }}>
                    <h3 style={{ margin: "0 0 6px" }}>Kior Healthcare</h3>
                    <p style={{ margin: "0 0 8px", fontSize: "13px" }}>
                      Diagnostic & Imaging Center
                      <br />
                      Mohali, Punjab
                      <br />
                      Open 24 Hours
                    </p>
                    <a
                      href="https://maps.app.goo.gl/BQhRSGEqKsCjsQqw9"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Get Directions
                    </a>
                  </div>
                </InfoWindow>
              )}
            </GoogleMap>
          </LoadScript>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
